import { BugWorkflowGeneratedEntity } from "./generated/BugWorkflowGeneratedEntity";

export abstract class BugWorkflowEntity extends BugWorkflowGeneratedEntity {
    // Comment to preserve new line
}
